import { development, releaseName } from 'app/config/constants'
import { when } from 'mobx'
import { store } from 'store/store'
import { Meta } from 'type/Options'
import { postMessageSelf } from 'util/message'
import { getLocationHash } from 'util/tg'

function getParams(): Record<string, string> {
  const params = Object.fromEntries(new URLSearchParams(location.search))
  if (development) {
    params.product ??= '9d75dd0d'
    params.item ??= '01f5fe4d'
  }
  return params
}

function getMeta(): Meta {
  return {
    location: location.href,
    hash: getLocationHash(),
    self: true,
  }
}

function getOpen(): object {
  const params = getParams()
  const item = params.tgWebAppStartParam ?? params.item
  if (!item) throw new Error('no item')
  return { item }
}

async function getOptions(): Promise<object> {
  const params = getParams()
  const product = params.product
  if (!product) throw new Error('no product')
  const telegram = true
  const stand = params.stand != null
  return { product, telegram, stand }
}

async function go() {
  console.info('try on', releaseName)
  const meta = getMeta()
  const open = getOpen()
  const options = await getOptions()
  postMessageSelf('setup', { options, meta })
  await when(() => store.setupDone)
  postMessageSelf('open', open)
}

export function telegram() {
  if (location.pathname === '/app') void go()
}
